const styles = theme => ({
  root: {
    padding: theme.spacing(2.5),
  },
})

export default styles
